/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable prefer-destructuring */
/* eslint-disable class-methods-use-this */
/* eslint-disable no-param-reassign */
/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable @typescript-eslint/no-useless-constructor */
/* eslint-disable @typescript-eslint/no-use-before-define */
import {
  Component,
  EventEmitter,
  forwardRef,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import {
  MatAutocompleteSelectedEvent,
  MatAutocompleteTrigger,
} from '@angular/material/autocomplete';
import { isEqual } from 'lodash';
import { Observable, of } from 'rxjs';
import { debounceTime, distinctUntilChanged, filter, map, switchMap } from 'rxjs/operators';
import { ClaimantSearchResponse } from 'src/app/cms/models/claimant-search-response.model';
import { CmsClaimantService } from 'src/app/cms/services/cms-claimant.service';
import { SSN4_EMPTY_REGEX, SSN4_REGEX } from '../../app.const';

@Component({
  standalone: false,
  selector: 'cms-ssn-autocomplete',
  templateUrl: './ssn-autocomplete.component.html',
  styleUrls: ['./ssn-autocomplete.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SsnAutocompleteComponent),
      multi: true,
    },
    CmsClaimantService,
  ],
})
export class SsnAutocompleteComponent implements ControlValueAccessor, OnInit {
  @ViewChild('autocompleteTriggerRef', { static: true })
  autocompleteTriggerRef: MatAutocompleteTrigger;

  @Input() panelWidth = 'auto';

  @Input() disabled = false;

  @Input() autocompleteDisabled = false;

  @Input() highlightIfSet: boolean;

  @Input() readonlySsn4 = false;

  @Output() optionSelected = new EventEmitter<ClaimantSearchResponse>();

  myControl = new FormControl('');

  filteredOptions: Observable<any[]>;

  val: string = '___-__-____';

  isReadonlySsn4Mode: boolean = false;

  private initialized = false;

  private readonly placeholderChar = '_';

  private readonly separator = '-';

  private readonly emptyStr = '___-__-';

  // Positions of editable digit slots in the 11-char string "XXX-XX-XXXX"
  private readonly digitSlots = [0, 1, 2, 4, 5, 7, 8, 9, 10];

  constructor(private cmsClaimantSvc: CmsClaimantService) {}

  onChange: any = () => {};

  onTouch: any = () => {};

  set value(val: string) {
    this.val = val;
    this.updateControlValue();
    if (!val || SSN4_EMPTY_REGEX.test(val)) {
      this.onChange(null);
      if (this.initialized) this.onTouch();
      return;
    }

    const formatted = this.formatedValToObj(val);
    this.onChange(formatted);
    if (this.initialized) this.onTouch();
  }

  get value() {
    return this.val;
  }

  ngOnInit() {
    this.filteredOptions = this.myControl.valueChanges.pipe(
      filter((value: any) => !this.autocompleteDisabled),
      distinctUntilChanged((prev: any, curr: any) => isEqual(prev, curr)),
      debounceTime(200),
      switchMap((value: SsnOrSsn4 | ClaimantSearchResponse) => {
        if ((!value.ssn && !value.ssn4) || (value.ssn && value.ssn.length < 3)) {
          return of([]);
        }

        const newVal = value.ssn || value.ssn4;
        const ssnParam: 'ssn' | 'ssn4' = value.ssn ? 'ssn' : 'ssn4';

        return this.cmsClaimantSvc
          .searchClaimant({ [ssnParam]: newVal })
          .pipe(map((items: ClaimantSearchResponse[]) => this.formatOptions(items)));
      }),
    );
    setTimeout(() => { this.initialized = true; });
  }

  checkIsSsn4IsEmpty(value: string): boolean {
    return SSN4_EMPTY_REGEX.test(value);
  }

  writeValue(value: SsnOrSsn4) {
    if (!value) {
      this.val = '___-__-____';
      this.updateControlValue();
      return;
    }

    if (typeof value.ssn === 'string' && value.ssn.length) {
      this.useSsnKey(value.ssn);
      return;
    }

    if (typeof value.ssn4 === 'string' && value.ssn4.length) {
      this.useSsn4Key(value.ssn4);
      return;
    }

    this.val = '___-__-____';
    this.updateControlValue();
  }

  registerOnChange(fn: any) {
    this.onChange = fn;
  }

  registerOnTouched(onTouched: Function) {
    this.onTouch = onTouched;
  }

  onInput(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.value !== this.val) {
      input.value = this.val;
    }
  }

  onPaste(event: ClipboardEvent) {
    event.preventDefault();
    const text = event.clipboardData?.getData('text') ?? '';
    const digits = text.replace(/\D/g, '');

    if (!digits.length) return;

    const input = event.target as HTMLInputElement;
    const cursorPos = input.selectionStart ?? 0;

    if (digits.length >= 9) {
      this.value = this.ssnToFromatSsn(digits.slice(0, 9));
      input.value = this.val;
      input.setSelectionRange(11, 11);
      setTimeout(() => input.setSelectionRange(11, 11), 0);
      return;
    }

    if (digits.length === 4 && cursorPos >= 7) {
      this.value = this.ssn4ToFormatSsn4(digits);
      input.value = this.val;
      input.setSelectionRange(11, 11);
      setTimeout(() => input.setSelectionRange(11, 11), 0);
      return;
    }

    const chars = this.val.split('');
    let digitIndex = 0;
    let lastFilledSlot = cursorPos;

    for (const slot of this.digitSlots) {
      if (slot >= cursorPos && digitIndex < digits.length) {
        chars[slot] = digits[digitIndex++];
        lastFilledSlot = slot;
      }
    }

    this.value = chars.join('');
    input.value = this.val;

    const nextSlot = this.digitSlots.find((s) => s > lastFilledSlot);
    const nextCursor = nextSlot !== undefined ? nextSlot : lastFilledSlot + 1;
    input.setSelectionRange(nextCursor, nextCursor);
    setTimeout(() => input.setSelectionRange(nextCursor, nextCursor), 0);
  }

  openPanelOptions(event: MouseEvent) {
    if (this.autocompleteDisabled) {
      return;
    }
    const visibleInput = event.target as HTMLInputElement;
    visibleInput.focus();

    if (!this.val || SSN4_EMPTY_REGEX.test(this.val)) {
      event.stopPropagation();
      this.autocompleteTriggerRef.openPanel();
    }
  }

  onKeydown(event: KeyboardEvent) {
    // Allow browser to handle clipboard, navigation, tab
    if (event.ctrlKey || event.metaKey || event.altKey) {
      return;
    }
    if (['Tab', 'Home', 'End', 'ArrowLeft', 'ArrowRight'].includes(event.key)) {
      return;
    }

    const input = event.target as HTMLInputElement;
    const cursorPos = input.selectionStart ?? 0;

    if (/^\d$/.test(event.key)) {
      event.preventDefault();

      const slot = this.digitSlots.find(s => s >= cursorPos);
      if (slot === undefined) return;

      const chars = this.val.split('');
      chars[slot] = event.key;
      this.value = chars.join('');
      input.value = this.val;

      const nextSlot = this.digitSlots.find(s => s > slot);
      const nextCursor = nextSlot !== undefined ? nextSlot : slot + 1;
      input.setSelectionRange(nextCursor, nextCursor);
      setTimeout(() => input.setSelectionRange(nextCursor, nextCursor), 0);

    } else if (event.key === 'Backspace') {
      event.preventDefault();

      const slot = [...this.digitSlots].reverse().find(s => s < cursorPos);
      if (slot === undefined) return;

      const chars = this.val.split('');
      chars[slot] = '_';
      this.value = chars.join('');
      input.value = this.val;

      input.setSelectionRange(slot, slot);
      setTimeout(() => input.setSelectionRange(slot, slot), 0);

    } else if (event.key === 'Delete') {
      event.preventDefault();

      const slot = this.digitSlots.find(s => s >= cursorPos);
      if (slot === undefined) return;

      const chars = this.val.split('');
      chars[slot] = '_';
      this.value = chars.join('');
      input.value = this.val;

      input.setSelectionRange(cursorPos, cursorPos);
      setTimeout(() => input.setSelectionRange(cursorPos, cursorPos), 0);

    } else {
      event.preventDefault();
    }
  }

  onOptionSelected(event: MatAutocompleteSelectedEvent) {
    const optionVal: ClaimantSearchResponse = event.option.value;
    this.optionSelected.emit(optionVal);

    if (optionVal.ssn) {
      this.value = this.ssnToFromatSsn(optionVal.ssn);
    } else {
      this.value = this.ssn4ToFormatSsn4(optionVal.ssn4);
    }
  }

  private useSsnKey(ssn: string) {
    this.val = this.ssnToFromatSsn(ssn);
    this.updateControlValue();
  }

  private useSsn4Key(ssn4: string) {
    if (this.readonlySsn4) {
      this.isReadonlySsn4Mode = true;
    } else {
      this.isReadonlySsn4Mode = false;
    }

    this.val = this.ssn4ToFormatSsn4(ssn4);
    this.updateControlValue();
  }

  private updateControlValue() {
    const ssnOrSsn4 = this.formatedValToObj(this.val);
    this.myControl.setValue(ssnOrSsn4 as any);
  }

  private formatOptions(items: ClaimantSearchResponse[]) {
    items.forEach((item: ClaimantSearchResponse) => {
      item.formatOption = `${
        item.ssn ? this.formatSsnForOption(item.ssn) : this.formatSsn4ForOption(item.ssn4)
      } | ${item.firstName} ${item.lastName}`;
    });

    return items;
  }

  private formatSsnForOption(ssn: string) {
    return `${ssn.substring(0, 3)}${this.separator}${ssn.substring(3, 5)}${
      this.separator
    }${ssn.substring(5, 9)}`;
  }

  private formatSsn4ForOption(ssn4: string) {
    return `${this.emptyStr}${ssn4}`;
  }

  private ssnToFromatSsn(ssn: string) {
    return `${ssn.substring(0, 3)}${this.separator}${ssn.substring(3, 5)}${
      this.separator
    }${ssn.substring(5, 9)}`;
  }

  private ssn4ToFormatSsn4(ssn4: string) {
    return `${this.emptyStr}${ssn4}`;
  }

  private formatedValToObj(formatedVal: string): SsnOrSsn4 {
    const ssnOrSsn4: SsnOrSsn4 = { ssn: '', ssn4: '' };

    const valArray = formatedVal.split(this.emptyStr);

    if (valArray.length === 2) {
      ssnOrSsn4.ssn = '';

      if (SSN4_REGEX.test(valArray[1])) {
        ssnOrSsn4.ssn4 = valArray[1];
      }
    } else {
      let str = '';

      for (let i = 0; i < formatedVal.length; i++) {
        const char = formatedVal.charAt(i);
        if (char !== this.separator && char !== this.placeholderChar) {
          str += char;
        }
      }

      ssnOrSsn4.ssn4 = '';
      ssnOrSsn4.ssn = str;

      if (str.length === 9) {
        ssnOrSsn4.ssn4 = formatedVal.split(this.separator)[2];
      }
    }

    return ssnOrSsn4;
  }

  reset() {
    this.isReadonlySsn4Mode = false;
    this.writeValue({});
    this.onChange(null);
    this.onTouch(null);
  }
}

export interface SsnOrSsn4 {
  ssn?: string;
  ssn4?: string;
}
